import { render, staticRenderFns } from "./ControlSwitch.vue?vue&type=template&id=36dd81fe&scoped=true&"
import script from "./ControlSwitch.vue?vue&type=script&lang=js&"
export * from "./ControlSwitch.vue?vue&type=script&lang=js&"
import style0 from "./ControlSwitch.vue?vue&type=style&index=0&id=36dd81fe&lang=scss&scoped=true&"
import style1 from "./ControlSwitch.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dd81fe",
  null
  
)

export default component.exports